<template>
  <el-select
    v-if="control == 'select'"
    v-model="model[property]"
    :multiple="data.maxNumber > 1"
    :multiple-limit="data.maxNumber > 1 ? Math.min(data.maxNumber, data.options.length) : data.options.length"
    @change="handleChange"
  >
    <el-option v-for="item in data.options" :key="item.code" :label="item.title" :value="item.code" />
  </el-select>

  <el-input @change="handleChange" v-else-if="control == 'multiline'" type="textarea" rows="5" v-model="model.text[data.options[0].code]" />

  <el-input @change="handleChange" v-else-if="control == 'textbox'" v-model="model.text[data.options[0].code]" />

  <el-radio-group @change="handleChange" v-else-if="control == 'radio'" v-model="model[property]" class="ml-4">
    <div v-for="it in data.options" :key="it.code" class="item" :class="{ 'is--text': it.text }">
      <el-radio :label="it.code">{{ it.title }}</el-radio>
      <el-input v-if="it.text" v-model="model.text[it.code]" @focus="handleFocus(it)" @change="handleChange" />
    </div>
  </el-radio-group>

  <el-checkbox-group @change="handleChange" v-else v-model="model[property]" :max="data.maxNumber > 1 ? Math.min(data.maxNumber, data.options.length) : data.options.length">
    <div v-for="it in data.options" :key="it.code" class="item" :class="{ 'is--text': it.text }">
      <el-checkbox :label="it.code">{{ it.title }}</el-checkbox>
      <el-input v-if="it.text" v-model="model.text[it.code]" @focus="handleFocus(it)" @change="handleChange" />
    </div>
  </el-checkbox-group>
</template>
<script setup>
  import { ref, onMounted, computed, watch } from 'vue'
  const props = defineProps({
    modelValue: {
      type: Object,
      default: () => {
        return {}
      },
    },
    data: {
      type: Object,
      default: () => {
        return {
          control: 'select',
          options: [],
        }
      },
    },
  })

  const emit = defineEmits(['update:modelValue'])

  const control = computed(() => {
    let val = props.data.control
    let max = props.data.maxNumber || 0
    let hasText = props.data.options.some((item) => item.text === true)
    if (val === 'select' && !hasText) {
      return val
    }
    if (props.data.options.length == 1 && props.data.options[0].text) {
      if (val === 'multiline') {
        return 'multiline'
      }
      return 'textbox'
    }
    //
    if (val === 'radio') {
      return max == 0 ? val : 'checkbox'
    }
    return max == 1 ? 'radio' : 'checkbox'
  })
  const property = computed(() => {
    if (control.value === 'checkbox' || (control.value === 'checkbox' && props.data.maxNumber > 1) || (control.value === 'select' && props.data.maxNumber > 1)) {
      return 'multiple'
    }
    return 'single'
  })

  const model = ref({
    single: '',
    multiple: [],
    text: {},
  })

  watch(
    () => props.modelValue,
    () => {
      let mv = props.modelValue || {}
      let values = {
        single: '',
        multiple: [],
        text: {},
      }
      if (control.value == 'textbox' || control.value == 'multiline') {
        values.single = props.data.options[0].code
        values.multiple = [props.data.options[0].code]
        values.text[props.data.options[0].code] = mv[props.data.options[0].code] || ''
      } else {
        for (var opt of props.data.options) {
          if (mv.hasOwnProperty(opt.code)) {
            values.single = opt.code
            values.multiple.push(opt.code) //
          }
          values.text[opt.code] = mv[opt.code] || ''
        }
      }
      model.value = values
    },
    {
      deep: true,
    }
  )
  //
  onMounted(() => {
    //
    let mv = props.modelValue || {}
    let values = {
      single: '',
      multiple: [],
      text: {},
    }
    if (control.value == 'textbox' || control.value == 'multiline') {
      values.single = props.data.options[0].code
      values.multiple = [props.data.options[0].code]
      values.text[props.data.options[0].code] = mv[props.data.options[0].code] || ''
    } else {
      for (var opt of props.data.options) {
        if (mv.hasOwnProperty(opt.code)) {
          values.single = opt.code
          values.multiple.push(opt.code) //
        }
        values.text[opt.code] = mv[opt.code] || ''
      }
    }
    model.value = values
    console.log('modelValue', props.modelValue, model.value)
    handleChange()
  })

  //
  const handleChange = () => {
    let mv = {}
    let val = []
    if (control.value == 'textbox' || control.value == 'multiline') {
      val = [model.value['single']]
    } else {
      val = property.value === 'single' ? [model.value[property.value]] : model.value[property.value]
    }
    for (var opt of props.data.options) {
      if (opt.code && val.indexOf(opt.code) >= 0) {
        mv[opt.code] = model.value.text[opt.code]
      }
    }
    console.log('handleChange mv', mv, val, control.value, property.value)

     // 只在数据实际变化时触发
    const currentValue = JSON.stringify(props.modelValue)
    const newValue = JSON.stringify(mv)
    
    if (currentValue !== newValue) {
      emit('update:modelValue', mv)
      emit('change', mv)
    }
  }

  const handleFocus = (it) => {
    console.log('handleFocus')
    let mv = {}
    //mv[it.code] = model.value.text[it.code]
    model.value.single = it.code
    if (model.value.multiple.indexOf(it.code) <= 0) {
      model.value.multiple.push(it.code)
    }
    let val = []
    if (control.value == 'textbox' || control.value == 'multiline') {
      val = [model.value['single']]
    } else {
      val = property.value === 'single' ? [model.value[property.value]] : model.value[property.value]
    }
    for (var opt of props.data.options) {
      if (opt.code && val.indexOf(opt.code) >= 0) {
        mv[opt.code] = model.value.text[opt.code]
      }
    }

    emit('update:modelValue', mv)
    emit('change', mv)
  }
</script>

<style lang="scss" scoped>
  .el-radio-group,
  .el-checkbox-group {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .item {
      margin-right: 12px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      &:last-child {
        margin-right: 0;
      }
      .el-radio,
      .el-checkbox {
        margin-right: 0px;
        display: flex;
        height: auto;
        align-items: flex-start;
        min-height: 20px;
        margin-top: 12px;
        margin-bottom: 6px;
        box-sizing: border-box;
        :deep() {
          .el-radio__input,
          .el-checkbox__input {
            margin-top: 4px;
          }

          .el-radio__label,
          .el-checkbox__label {
            height: auto;
            flex: 1;
            white-space: pre-wrap;
            line-height: 20px;
            margin-top: 0 !important;
            //white-space: w;
          }
        }
      }

      &.is--text {
        width: 100%;
        margin-bottom: 12px;
        flex-wrap: wrap;
        .el-radio,
        .el-checkbox {
          margin-right: 12px;
          margin-bottom: 6px;
        }
        .el-input {
          margin-left: 0;
          flex: 1;
          min-width: 300px;
        }
      }
    }
  }

  @media (max-width: 767px) {
    .el-radio-group,
    .el-checkbox-group {
      .item {
        width: 100%;
        margin-right: 0;
        margin-left: 0;
        &.is--text {
          flex-direction: column;
          .el-radio,
          .el-checkbox {
            flex: auto;
            margin-right: 0;
            width: 100%;
          }
          .el-input {
            flex: 1;
           padding-left: 21px;
          }
        }
      }
    }
  }
</style>
